export default __webpack_public_path__ + "static/media/draw_line.4b312526.svg";